'use strict';
plateCostController.$inject = ['$scope', '$q', '$interval', 'reportHelper', 'schoolNutritionService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('plateCostController', plateCostController);

function plateCostController($scope, $q, $interval, reportHelper, schoolNutritionService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.vm.busyPromise = $q.all([$scope.vm.loadSNFiscalYears($scope.vm)]);

	function getViewModel() {
		var model = {
			fiscalMonths: [
				{ Month: 7, MonthName: 'July' },
				{ Month: 8, MonthName: 'August' },
				{ Month: 9, MonthName: 'September' },
				{ Month: 10, MonthName: 'October' },
				{ Month: 11, MonthName: 'November' },
				{ Month: 12, MonthName: 'December' },
				{ Month: 1, MonthName: 'January' },
				{ Month: 2, MonthName: 'February' },
				{ Month: 3, MonthName: 'March' },
				{ Month: 4, MonthName: 'April' },
				{ Month: 5, MonthName: 'May' },
				{ Month: 6, MonthName: 'June' },
			],
			fiscalYears: [],
			snSites: [],
			sitesCheckAll: false,
			report: {
				fiscalYear: null,
				fromMonth: null,
				toMonth: null,
			},
			busyMessage: BUSY_MESSAGE.Loading,
			busyPromise: null,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.report.fiscalYear) {
				model.validationErrors.push('Please select a Fiscal Year.');
				isValid = false;
			}

			var siteIds = [];
			_.find(model.snSites, function (site) {
				if (site.Selected === true) {
					siteIds.push(site.SiteId);
				}
			});

			if (siteIds.length === 0) {
				model.validationErrors.push('Please select one or more sites to continue.');
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) return false;

			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			model.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var siteIds = [];
			_.find(model.snSites, function (site) {
				if (site.Selected === true) {
					siteIds.push(site.SiteId);
				}
			});

			var report = {
				FiscalYear: model.report.fiscalYear,
				MonthFrom: model.report.fromMonth,
				MonthTo: model.report.toMonth,
				SiteIds: siteIds,
			};

			reportHelper.postReport($scope, '/api/fundreports/platecostreport', report, 'PlateCostReport.pdf');
		}

		function toggleSelection(model, SiteId) {
			if (typeof SiteId === 'undefined') {
				angular.forEach(model.snSites, function (site) {
					site.Selected = model.sitesCheckAll;
				});
			} else {
				let selectCount = 0;
				angular.forEach(model.snSites, function (site) {
					if (site.SiteId === SiteId) {
						site.Selected = !site.Selected;
					}
					if (site.Selected === true) {
						selectCount++;
					}
				});

				model.sitesCheckAll = model.snSites.length === selectCount;
			}
		}

		function loadSNFiscalYears(model) {
			return schoolNutritionService.getSchoolNutritionFiscalYears().then(_.partial(finishLoadingFiscalYears, model));

			function finishLoadingFiscalYears(model, response) {
				if (response.data.isValid === true) {
					model.fiscalYears = response.data.fiscalYears;
					if (model.fiscalYears.length > 0) {
						model.report.fiscalYear = model.fiscalYears[0];

						let curMonth = parseInt(moment().format('MM'));
						model.report.fromMonth = curMonth;
						model.report.toMonth = curMonth;

						return model.loadSNSites($scope.vm);
					}
				} else {
					vm.errors = response.data.errors;
				}
			}
		}

		function loadSNSites(model) {
			model.busyMessage = BUSY_MESSAGE.Loading;
			model.busyPromise = schoolNutritionService.getSchoolNutritionSites(model.report.fiscalYear).then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.snSites = response.data.sites;
				model.sitesCheckAll = false;
			}
		}

		return angular.extend(model, {
			loadSNFiscalYears: _.partial(loadSNFiscalYears, model),
			loadSNSites: _.partial(loadSNSites, model),
			toggleSelection: _.partial(toggleSelection, model),
			openReport: _.partial(openReport, model),
		});
	}
}
